import React, { useEffect, useState } from 'react';
import { Alert, Button, Container } from 'react-bootstrap';

export default function PaymentSuccess() {
  const [seconds, setSeconds] = useState(10);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (seconds <= 0) {
      window.close();
      // Fallback if window.close() was blocked
      setClosed(true);
      return;
    }
    const timer = setTimeout(() => setSeconds((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconds]);

  function handleCloseTab() {
    window.close();
    setClosed(true);
  }

  return (
    <Container className="py-5 rwm-payment-success">
      <Alert variant="success" data-testid="rwm-payment-success-message">
        <h1 className="h4 mb-2">✓ Payment successful!</h1>
        <p className="mb-0">Your listing credits have been added to your account.</p>
      </Alert>
      <p
        className="text-muted text-center mt-3"
        data-testid="rwm-payment-success-countdown"
      >
        {closed
          ? 'You can now close this tab.'
          : `This tab will close in ${seconds} second${seconds !== 1 ? 's' : ''}.`}
      </p>
      <div className="text-center mt-2">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={handleCloseTab}
          data-testid="rwm-payment-success-close-btn"
        >
          Close this tab
        </Button>
      </div>
    </Container>
  );
}
